// Controls-coverage findings types — wire shape from
// src/ai_alm/api/routes/controls_coverage_findings.py.

export type ControlsCoverageFindingKind =
  | 'missing_in_scope_control'
  | 'no_hazard_tables'

export type ControlsCoverageFindingSeverity = 'critical' | 'high' | 'medium'

export interface ControlsCoverageFindingRow {
  finding_kind: ControlsCoverageFindingKind
  severity: ControlsCoverageFindingSeverity
  rule_source: string
  message: string
  cites: string[]
  clause: string | null
  suggested_fix: string | null
  /** Stable identity echoed back to the finding-waivers route. */
  finding_key: string
  /** True when an unexpired waiver already accepts this finding. */
  waived: boolean
  /** Accepted-waiver justification, when waived. */
  waiver_justification: string | null
}

/** PEG invariant id this panel's findings belong to. */
export const CC_INVARIANT_ID = 'PEG-CONTROLS-COVERAGE-COMPLETENESS-001'

export interface InScopeControlRow {
  clause: string
  purpose: string
  rule_source: string
  cites: string[]
}

export interface ControlsCoverageFindingsResponse {
  findings: ControlsCoverageFindingRow[]
  in_scope_controls: InScopeControlRow[]
  regulatory: string[]
  shape: string | null
  compliance_risks_present: boolean
}

// UI palette — severity → chip class
export const CC_SEVERITY_PALETTE: Record<
  ControlsCoverageFindingSeverity,
  { label: string; chipClass: string }
> = {
  critical: {
    label: 'Critical',
    chipClass: 'bg-red-950/40 border-red-700/50 text-red-200',
  },
  high: {
    label: 'High',
    chipClass: 'bg-amber-950/40 border-amber-700/50 text-amber-200',
  },
  medium: {
    label: 'Medium',
    chipClass: 'bg-sky-950/40 border-sky-700/50 text-sky-200',
  },
}

// UI palette — finding-kind → human label
export const CC_KIND_LABEL: Record<ControlsCoverageFindingKind, string> = {
  missing_in_scope_control: 'Required control not cited',
  no_hazard_tables: 'No hazard tables',
}
